import Vuex, { GetterTree, ActionTree, MutationTree, Action } from 'vuex';

interface ICourseTypes {
  [key: string]: any;
  loading: boolean;
  infos: Array<{ [key: string]: any }>;
}
interface ICourseCategory {
  loading: boolean;
  result: object;
}
interface ICourseInfo {
  loading: boolean;
  result: object;
}
interface ICourseScore {
  loading: boolean;
  result: object;
}

export interface IState {
  [key: string]: any;
}

export const state: IState = {
  courseTypes: {
    loading: false,
    infos: []
  } as ICourseTypes,
  courseCategory: {
    loading: false,
    result: {
      total: 0,
      data: []
    }
  } as ICourseCategory,
  courseInfo: {
    loading: false,
    result: {}
  } as ICourseInfo,
  courseScore: {
    loading: false,
    result: {}
  } as ICourseScore,
  courseScoreSet: false,
  courseFeedback: false
};

// tslint:disable-next-line:ban-types
export const getters: GetterTree<IState, Function> = {
  courseTypes: (myState: IState) => myState.courseTypes,
  courseInfo: (myState: IState) => myState.courseInfo,
  courseCategory: (myState: IState) => myState.courseCategory,
  courseScore: (myState: IState) => myState.courseScore,
  courseScoreSet: (myState: IState) => myState.courseScoreSet,
  courseFeedback: (myState: IState) => myState.courseFeedback
};
